// extracted by mini-css-extract-plugin
export default {"topAdjustedForNavbars":"CJa6YZ7VKnYypBJyDw8h"};